import { gql } from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The AWSDateTime scalar type provided by AWS AppSync, represents a valid extended ISO 8601 DateTime string. In other
   * words, this scalar type accepts datetime strings of the form YYYY-MM-DDThh:mm:ss.SSSZ. The scalar can also accept
   * "negative years" of the form -YYYY which correspond to years before 0000. For example, "-2017-01-01T00:00Z" and
   * "-9999-01-01T00:00Z" are both valid datetime strings. The field after the two digit seconds field is a nanoseconds f
   * ield. It can accept between 1 and 9 digits. So, for example, "1970-01-01T12:00:00.2Z", "1970-01-01T12:00:00.277Z" and
   * "1970-01-01T12:00:00.123456789Z" are all valid datetime strings. The seconds and nanoseconds fields are optional
   * (the seconds field must be specified if the nanoseconds field is to be used). The time zone offset is compulsory for
   * this scalar. The time zone offset must either be Z (representing the UTC time zone) or be in the format ±hh:mm:ss.
   * The seconds field in the timezone offset will be considered valid even though it is not part of the ISO 8601 standard.
   */
  AWSDateTime: { input: any; output: any; }
  AWSEmail: { input: any; output: any; }
  /**
   * The AWSJSON scalar type provided by AWS AppSync, represents a JSON string that complies with RFC 8259. Maps like
   * "{\"upvotes\": 10}", lists like "[1,2,3]", and scalar values like "\"AWSJSON example string\"", "1", and "true"
   * are accepted as valid JSON and will automatically be parsed and loaded in the resolver mapping templates as Maps,
   * Lists, or Scalar values rather than as the literal input strings. Invalid JSON strings like "{a: 1}", "{'a': 1}"
   * and "Unquoted string" will throw GraphQL validation errors.
   */
  AWSJSON: { input: any; output: any; }
  AWSPhone: { input: any; output: any; }
  /**
   * The AWSURL scalar type provided by AWS AppSync, represents a valid URL string (Ex: https://www.amazon.com/). The URL
   * may use any scheme and may also be a local URL (Ex: http://localhost/). URLs without schemes like "amazon.com" or
   * "www.amazon.com" are considered invalid. URLs which contain double slashes (two consecutive forward slashes) in
   * their path are also considered invalid.
   */
  AWSURL: { input: any; output: any; }
};

/**
 * Representation of an airline with its code, name, and possessive form.
 * Even though the term airline is used, it also represents content recipients other than airlines.
 */
export type Airline = {
  __typename?: 'Airline';
  /** Name of the airline as displayed in the user interface. */
  airline_name?: Maybe<Scalars['String']['output']>;
  /** Possessive form of the airline name, such as "Austrian Airlines'" or "Aeroflot's". */
  airline_possessive?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the airline  / content recipient, such as the IATA 2-letter code. */
  iata_code?: Maybe<Scalars['String']['output']>;
  /** DRMtoday organization used for previewing content. */
  preview_organization?: Maybe<Scalars['String']['output']>;
  /** DRMtoday organization used for controlling access to the production content. */
  prod_organization?: Maybe<Scalars['String']['output']>;
};

/** A list of airlines visible to the requesting user. */
export type AirlinesPayload = {
  __typename?: 'AirlinesPayload';
  /** list of airlines */
  airlines: Array<Airline>;
};

export enum CodecType {
  /** Audio track. */
  Audio = 'audio',
  /** Burnt-in closed caption track. Fulfilled by closedcaption or subtitle source tracks. */
  BurntinClosedcaption = 'burntin_closedcaption',
  /** Burnt-in subtitle track. Fulfilled by subtitle or closedcaption source tracks. */
  BurntinSubtitle = 'burntin_subtitle',
  /** Closed caption track. */
  Closedcaption = 'closedcaption',
  /** Image track/file. */
  Image = 'image',
  /** Subtitle track. */
  Subtitle = 'subtitle',
  /** Video track. */
  Video = 'video'
}

export type DownloadPayload = {
  __typename?: 'DownloadPayload';
  /** A short-lived HTTPS link to download an `Encode` */
  link?: Maybe<Scalars['String']['output']>;
};

/** Represents a file produced as part of a workflow result. */
export type Encode = {
  __typename?: 'Encode';
  /** Unique identifier for the file, in the format of s3://bucket/path/filename.mp4. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Last modification date of the file in ISO 8601 date string format. */
  last_modified?: Maybe<Scalars['String']['output']>;
  /** Human-readable name of the file, typically the last part of the file's ID. */
  name?: Maybe<Scalars['String']['output']>;
  /** Size of the file in bytes. */
  size?: Maybe<Scalars['Float']['output']>;
};

export type FilterAwsDateTimeInput = {
  between?: InputMaybe<Array<Scalars['AWSDateTime']['input']>>;
  gt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  lt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

/** Used to filter items based on the value of a string property. */
export type FilterStringInput = {
  /** The result set will only include items whose property value matches the filter value. */
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type ListPOsInput = {
  filter?: InputMaybe<PoFilter>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Publish given PO items and finalize PO. */
  publish: WorkflowProcessPayload;
  /** @deprecated Field no longer supported */
  publishPo: WorkflowProcessPayload;
  /** Publish a single PO item. */
  publishPoItem: WorkflowProcessPayload;
  /** Registers a webhook to the process. The webhook will be called when the process reaches a terminal state. */
  registerWebhook: WorkflowProcessPayload;
  /** Restart a PO item that has failed or needs to be re-run for other reasons. */
  restartPoItem: WorkflowProcessPayload;
  start_workflow_above_default: WorkflowProcessPayload;
  /** Start a default content delivery workflow from an external ID. */
  start_workflow_default: WorkflowProcessPayload;
  start_workflow_lsy_order: WorkflowProcessPayload;
  /** Start a VOD workflow that emits a number if individualized, watermarked streams. */
  start_workflow_vod_batch: WorkflowProcessPayload;
  /** Start a VOD workflow that emits a single stream. */
  start_workflow_vod_default: WorkflowProcessPayload;
};


export type MutationPublishArgs = {
  input?: InputMaybe<PoInput>;
};


export type MutationPublishPoArgs = {
  input: PoItemInput;
};


export type MutationPublishPoItemArgs = {
  input: PoItemInput;
};


export type MutationRegisterWebhookArgs = {
  input: RegisterWebhookInput;
};


export type MutationRestartPoItemArgs = {
  input: PoItemInput;
};


export type MutationStart_Workflow_Above_DefaultArgs = {
  input: StartWorkflowAboveDefaultInput;
};


export type MutationStart_Workflow_DefaultArgs = {
  input: StartWorkflowDefaultInput;
};


export type MutationStart_Workflow_Lsy_OrderArgs = {
  input: StartWorkflowLsyInput;
};


export type MutationStart_Workflow_Vod_BatchArgs = {
  input: StartWorkflowVodInput;
};


export type MutationStart_Workflow_Vod_DefaultArgs = {
  input: StartWorkflowVodInput;
};

export type Po = {
  __typename?: 'PO';
  airline: Scalars['String']['output'];
  date_created?: Maybe<Scalars['AWSDateTime']['output']>;
  date_due?: Maybe<Scalars['String']['output']>;
  finalize_process?: Maybe<WorkflowProcessPayload>;
  /**
   * Array of documents generated while finalizing the PO.
   * When format is HTML, returns a single-item array containing the rendered HTML report.
   */
  finalize_reports: Array<Scalars['AWSJSON']['output']>;
  id: Scalars['ID']['output'];
  po_name: Scalars['ID']['output'];
  poitems: Array<PoItem>;
  /**
   * How many of the PO's items have been published successfully, as last computed in the background:
   * list_POs returns the value stored on the PO and queues a refresh when it is missing or older than
   * a few minutes, and a refresh is also queued whenever a process of the PO ends. Null until the
   * first refresh, and outside list_POs.
   */
  publish_summary?: Maybe<PoPublishSummary>;
  target_system?: Maybe<Scalars['String']['output']>;
};


export type PoFinalize_ReportsArgs = {
  format?: InputMaybe<ReportFormat>;
};


export type PoPoitemsArgs = {
  po_item_id?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for filtering Purchase Orders (POs) */
export type PoFilter = {
  /** Filter POs based on their airline name. */
  airline?: InputMaybe<FilterStringInput>;
  /** Filter POs based on their creation date. */
  date_created?: InputMaybe<FilterAwsDateTimeInput>;
  /** Filter POs based on their name. */
  po_name?: InputMaybe<FilterStringInput>;
};

export type PoInput = {
  /** name of the PO, consisting of the organization followed by an underscore and a custom name. */
  po_name: Scalars['String']['input'];
  /** An array of PO Item IDs that is to be published before the finalization. */
  publish_po_item_ids: Array<Scalars['String']['input']>;
  /** Whether or not to execute the workflow and format specific finalization of the PO. */
  skip_finalize: Scalars['Boolean']['input'];
};

/** A single item in a Purchase Order (PO). */
export type PoItem = {
  __typename?: 'POItem';
  /**
   * Output aspect ratio, in vtkpy's spelling. "passthrough" (the default, and what an absent value
   * means) delivers the source's own shape. "16/9" / "4/3" / "9/16" / "3/4" deliver that ratio,
   * stretching the picture to fill the frame. The same four with a "_framed" suffix deliver that
   * ratio with the picture fitted inside it and the remainder filled with black. A profile that
   * cannot deliver the requested ratio refuses the job rather than approximating it.
   */
  aspect_ratio?: Maybe<Scalars['String']['output']>;
  checkpoint_content_complete?: Maybe<Scalars['Boolean']['output']>;
  checkpoint_content_uploaded?: Maybe<Scalars['Boolean']['output']>;
  checkpoint_encodes_done?: Maybe<Scalars['Boolean']['output']>;
  checkpoint_metadata_available?: Maybe<Scalars['Boolean']['output']>;
  /** Content identifier of the source. */
  content_identifier: Scalars['String']['output'];
  /** Customer ID associated with the billing for this PO item. */
  customer?: Maybe<Scalars['String']['output']>;
  /** List of email addresses to notify about workflow success or failure. */
  email_notification?: Maybe<Array<Scalars['AWSEmail']['output']>>;
  /** List of email addresses to receive delivery reports on publish success. */
  email_notification_publish?: Maybe<Array<Scalars['AWSEmail']['output']>>;
  /**
   * S3 URI (e.g. s3://bucket/prefix/) of the folder where encoded output files are stored.
   * To list the files, query the content repository API's `folder(id: encode_location)` query.
   */
  encode_location?: Maybe<Scalars['String']['output']>;
  /**
   * Array of files produced to fulfill the PO item.
   * @deprecated Use encode_location and list files via the content repository API's folder query
   */
  encodes: Array<Encode>;
  /** Output filename used to start the workflow, with varying meanings depending on workflow and output format. */
  filename: Scalars['String']['output'];
  format_specific_data?: Maybe<Scalars['AWSJSON']['output']>;
  format_specific_data_json?: Maybe<Scalars['AWSJSON']['output']>;
  /** Unique identifier for the PO item, consisting of the po name and po_item_id. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Internal: S3 bucket/prefix of the media source location. */
  input_brefix: Scalars['String']['output'];
  metadata_message?: Maybe<Scalars['String']['output']>;
  metadata_source?: Maybe<Scalars['String']['output']>;
  /** Internal: S3 bucket/prefix of the target location. */
  output_brefix: Scalars['String']['output'];
  /** The PO that this PO item belongs to. */
  po?: Maybe<Po>;
  /** Destination for final delivery of the PO files. */
  po_destination?: Maybe<Scalars['String']['output']>;
  /** Identifier for the PO item within the PO. */
  po_item_id: Scalars['String']['output'];
  /** Information about the encode's preview, if available. */
  preview?: Maybe<PoItemPreview>;
  /** Feedback about the process that published the output files. */
  publish_process?: Maybe<WorkflowProcessPayload>;
  /**
   * Array of documents generated while publishing the files to their final destination.
   * When format is HTML, returns a single-item array containing the rendered HTML report.
   */
  publish_reports: Array<Scalars['AWSJSON']['output']>;
  /** Array of requested tracks, with the source property populated when a suitable source track is identified. */
  tracks: Array<Track>;
  /** @deprecated use vtk_jobs to cater for the possibility of multiple VTK jobs */
  vtk_job?: Maybe<VtkJob>;
  vtk_jobs: Array<VtkJob>;
  /** Identifier of the selected encoding template. */
  vtk_template?: Maybe<Scalars['String']['output']>;
  /** Indicator of whether to apply a forensic watermark according to APEX specification. */
  watermark?: Maybe<Scalars['Boolean']['output']>;
  /** Type of workflow: e.g. above_default, vod_default. */
  workflow: Scalars['String']['output'];
  /** Feedback about the process that generated the output files. */
  workflow_process?: Maybe<WorkflowProcessPayload>;
  wrap_up_workflow?: Maybe<Scalars['String']['output']>;
};


/** A single item in a Purchase Order (PO). */
export type PoItemPublish_ReportsArgs = {
  format?: InputMaybe<ReportFormat>;
};

export type PoItemInput = {
  /** Identifier for the PO item within the PO. */
  po_item_id: Scalars['String']['input'];
  /** Name of the PO, consisting of the organization followed by an underscore and a custom name. */
  po_name: Scalars['String']['input'];
};

export type PoItemPayload = {
  __typename?: 'POItemPayload';
  poitem?: Maybe<PoItem>;
};

/** Preview information for a Purchase Order (PO) item. */
export type PoItemPreview = {
  __typename?: 'POItemPreview';
  /** Session-specific token that must be included in all segment requests for generating a session-specific forensic watermark. */
  ab_token?: Maybe<Scalars['String']['output']>;
  /** Access token for authorization to access encrypted DASH or HLS files and manifests. */
  access_token?: Maybe<Scalars['String']['output']>;
  /** Last modified date of the DASH manifest. [Informational]. */
  dash_manifest_last_modified?: Maybe<Scalars['AWSDateTime']['output']>;
  /** URL to the Dynamic Adaptive Streaming over HTTP (DASH) manifest, if available. */
  dash_manifest_url?: Maybe<Scalars['AWSURL']['output']>;
  /** Short-lived DRMtoday upfront authentication token. */
  drmtoday_token?: Maybe<Scalars['String']['output']>;
  /** Last modified date of the HLS master playlist. [Informational]. */
  hls_manifest_last_modified?: Maybe<Scalars['AWSDateTime']['output']>;
  /** URL to the HTTP Live Streaming (HLS) master playlist, if available. */
  hls_manifest_url?: Maybe<Scalars['AWSURL']['output']>;
};

export type PoPublishSummary = {
  __typename?: 'POPublishSummary';
  /** Number of items whose publish process succeeded. */
  published: Scalars['Int']['output'];
  /** Number of items in the PO. */
  total: Scalars['Int']['output'];
};

export type POsPayload = {
  __typename?: 'POsPayload';
  pos: Array<Po>;
};

/** Input type used to update a process subscription. */
export type ProcessInput = {
  /** Type of action being performed by the process. */
  action?: InputMaybe<Scalars['String']['input']>;
  /** Optional additional information related to the action performed by the process. Typically set only when the process is in a terminal state. */
  data?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the process. */
  id: Scalars['ID']['input'];
  /** Input that was used to starrt the process. */
  input?: InputMaybe<Scalars['String']['input']>;
  /** Progress message to provide updates on the process status to the client. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Current state of the process. */
  state: ProcessStateEnum;
};

export enum ProcessStateEnum {
  Aborted = 'ABORTED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS'
}

export type Query = {
  __typename?: 'Query';
  /** Retrieves a list of airlines suitable for building a user interface. */
  airlines?: Maybe<AirlinesPayload>;
  /** Retrieves a list of POs filtered by airline, name, and/or date. */
  list_POs: POsPayload;
  /** Retrieves the status information of a long-running process. */
  process?: Maybe<WorkflowProcessPayload>;
  /**
   * What an encoding template supports (burnt-in text tracks, dynamic text tracks, forensic watermark,
   * track match rules), read from the template itself. Unknown templates are an error.
   */
  template_capabilities: TemplateCapabilities;
};


export type QueryList_POsArgs = {
  input: ListPOsInput;
};


export type QueryProcessArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTemplate_CapabilitiesArgs = {
  input: TemplateCapabilitiesInput;
};

/**
 * Input for registering a webhook to a process.
 *
 * When a process reaches a terminal state, the webhook will be called with a POST request containing the following JSON payload:
 *
 *     {
 *       "process_id": "process_id",
 *       "state": "state",
 *       "data": "data",
 *       "message": "message",
 *       "action": "action"
 *     }
 */
export type RegisterWebhookInput = {
  /** Unique identifier of the process to attach to. */
  process_id: Scalars['ID']['input'];
  /** URL to call when the process reaches a terminal state. */
  webhook_url: Scalars['AWSURL']['input'];
};

/** Format for delivery report output. */
export enum ReportFormat {
  /** Return a single HTML string with all reports rendered and CSS inlined. */
  Html = 'HTML',
  /** Return reports as JSON objects (default). */
  Json = 'JSON'
}

export type Source = {
  __typename?: 'Source';
  /** Type of the selected source track (audio, video, closed_caption, subtitle, or image). Depending on the workflow, closed captioning may be delivered instead of subtitles. */
  codec_type: Scalars['String']['output'];
  /** Index of the selected source track. */
  index: Scalars['Int']['output'];
  /** Object key of the selected source file, excluding the bucket. */
  key: Scalars['String']['output'];
  /** Language of the selected track. Depending on the workflow, similar languages may be delivered, such as fr-CA for fr, or es-419 for es-ES. */
  lang?: Maybe<Scalars['String']['output']>;
};

export type StartWorkflowAboveDefaultInput = {
  /**
   * Output aspect ratio, in vtkpy's spelling. "passthrough" (the default, and what an absent value
   * means) delivers the source's own shape. "16/9" / "4/3" / "9/16" / "3/4" deliver that ratio,
   * stretching the picture to fill the frame. The same four with a "_framed" suffix deliver that
   * ratio with the picture fitted inside it and the remainder filled with black. A profile that
   * cannot deliver the requested ratio refuses the job rather than approximating it.
   */
  aspect_ratio?: InputMaybe<Scalars['String']['input']>;
  /** Publishes the PO item automatically after successful completion of the workflow when set to true. */
  auto_publish?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of email addresses to notify about success/failure of the encode and failure of publish */
  email_notification?: InputMaybe<Array<Scalars['AWSEmail']['input']>>;
  /** List of email addresses to notify about success of publish */
  email_notification_publish?: InputMaybe<Array<Scalars['AWSEmail']['input']>>;
  /** Output filename used to start the workflow, with varying meanings depending on the workflow and output format. */
  filename: Scalars['String']['input'];
  /** VTK template-specific data structure. */
  format_specific_data?: InputMaybe<Scalars['AWSJSON']['input']>;
  /** S3 bucket/prefix of the media source location. */
  input_brefix: Scalars['String']['input'];
  /** Destination for final delivery of the PO files. */
  po_destination: Scalars['String']['input'];
  /** Identifier for the PO item within the PO. */
  po_item_id: Scalars['String']['input'];
  /** Name of the PO, consisting of the target organization followed by an underscore and a custom name. Please use a basic character set. */
  po_name: Scalars['String']['input'];
  /** Array of tracks to deliver. */
  tracks: Array<TrackInput>;
  /** Identifier of the encoding template to be used in this PO. */
  vtk_template: Scalars['String']['input'];
  /** Indicator of whether to apply a visual watermark according to APEX specification. */
  watermark: Scalars['Boolean']['input'];
};

export type StartWorkflowDefaultInput = {
  /**
   * Output aspect ratio, in vtkpy's spelling. "passthrough" (the default, and what an absent value
   * means) delivers the source's own shape. "16/9" / "4/3" / "9/16" / "3/4" deliver that ratio,
   * stretching the picture to fill the frame. The same four with a "_framed" suffix deliver that
   * ratio with the picture fitted inside it and the remainder filled with black. A profile that
   * cannot deliver the requested ratio refuses the job rather than approximating it.
   */
  aspect_ratio?: InputMaybe<Scalars['String']['input']>;
  /** Publishes the PO item automatically after successful completion of the workflow when set to true. */
  auto_publish?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identifier of the source content. This is the ID of the content that is to be used as the source for the workflow. */
  content_identifier: Scalars['String']['input'];
  /** List of email addresses to notify about success/failure of the encode and failure of publish */
  email_notification?: InputMaybe<Array<Scalars['AWSEmail']['input']>>;
  /** List of email addresses to notify about success of publish */
  email_notification_publish?: InputMaybe<Array<Scalars['AWSEmail']['input']>>;
  /** Output filename used to start the workflow, with varying meanings depending on the workflow and output format. */
  filename: Scalars['String']['input'];
  /** VTK template-specific data structure. */
  format_specific_data?: InputMaybe<Scalars['AWSJSON']['input']>;
  /** This is the URL of the metadata source that is to be used for the workflow. */
  metadata_source?: InputMaybe<Scalars['String']['input']>;
  /** Destination for final delivery of the PO files. */
  po_destination: Scalars['String']['input'];
  /** Identifier for the PO item within the PO. */
  po_item_id: Scalars['String']['input'];
  /** Name of the PO, consisting of the airline's 2-letter IATA code followed by an underscore and a custom name. Please use a basic character set. */
  po_name: Scalars['String']['input'];
  /** Array of tracks to deliver. */
  tracks: Array<TrackInput>;
  /** Identifier of the encoding template to be used in this PO. */
  vtk_template: Scalars['String']['input'];
  /** Indicator of whether to apply a visual watermark according to APEX specification. */
  watermark: Scalars['Boolean']['input'];
  /** This is the URL of the metadata source that is to be used for the workflow. */
  wrap_up_workflow?: InputMaybe<Scalars['String']['input']>;
};

export type StartWorkflowLsyInput = {
  /**
   * Output aspect ratio, in vtkpy's spelling. "passthrough" (the default, and what an absent value
   * means) delivers the source's own shape. "16/9" / "4/3" / "9/16" / "3/4" deliver that ratio,
   * stretching the picture to fill the frame. The same four with a "_framed" suffix deliver that
   * ratio with the picture fitted inside it and the remainder filled with black. A profile that
   * cannot deliver the requested ratio refuses the job rather than approximating it.
   */
  aspect_ratio?: InputMaybe<Scalars['String']['input']>;
  email_notification?: InputMaybe<Array<Scalars['AWSEmail']['input']>>;
  filename: Scalars['String']['input'];
  format_specific_data?: InputMaybe<Scalars['AWSJSON']['input']>;
  /** S3 bucket/prefix of the media source location. */
  input_brefix: Scalars['String']['input'];
  po_destination: Scalars['String']['input'];
  po_item_id: Scalars['String']['input'];
  po_name: Scalars['String']['input'];
  tracks: Array<TrackInput>;
  vtk_template: Scalars['String']['input'];
  /** Indicator of whether to apply a watermark. */
  watermark: Scalars['Boolean']['input'];
};

/** Input for the VOD workflow. */
export type StartWorkflowVodInput = {
  /** Publishes the PO item automatically after successful completion of the workflow when set to true. */
  auto_publish?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of email addresses to notify about success or failure of the workflow. */
  email_notification?: InputMaybe<Array<Scalars['AWSEmail']['input']>>;
  /**
   * VTK template-specific settings, as a JSON object. What it may contain depends on `vtk_template`. Numeric fields are JSON numbers; fields whose contract is string-valued (for example bitrate strings and the v1 ContentArmor settings) remain strings.
   *
   * ## `cmaf-abr-v2` (start_workflow_vod_default)
   *
   * The complete contract is a JSON Schema (draft 2020-12), published with the template in vtkpy: `schemas/vod-default-cmaf-abr-v2.format_specific_data.schema.json`, also available as `VtkTemplateCmafAbrV2.format_specific_data_schema()`. A few rules that compare list entries are stated in its descriptions and checked only when the job renders. Unknown keys inside `stardustmark` and `encoding_ladder` are refused. Unknown top-level keys are ignored.
   *
   *     {
   *       "encrypt": true,
   *       "protection_systems": ["Widevine", "PlayReady", "FairPlay"],
   *       "thumbs": false,
   *       "watermark": "stardustmark",
   *       "stardustmark": {
   *         "wm_id": 1234, "bit_profile": 13, "strength": 4,
   *         "pixel_density": 60, "superpixel_density": 60,
   *         "pm_mode": 2, "seed": -1
   *       },
   *       "encoding_ladder": {
   *         "codec": "h264", "crf": 23, "outputs": ["dash", "hls"],
   *         "renditions": [
   *           {"width": 1280, "max_bitrate": "4000k"},
   *           {"width": 1920, "max_bitrate": "12000k"}
   *         ]
   *       }
   *     }
   *
   * - `watermark`: `"stardustmark"` or null. For ContentArmor A/B watermarking, use `cmaf-abr` (below). The v1 spellings (`"stardust/sf"`, flat `sd_*` keys) do not apply to this template.
   * - `stardustmark`: required when `watermark` is `"stardustmark"`. Integers:
   *   - `wm_id` (required): 0 to 2^bit_profile - 1
   *   - `bit_profile` (required): 1-256; the UI offers 8, 13, 16, 24, 32
   *   - `strength` (required): 1-20
   *   - `pixel_density`, `superpixel_density` (required): 1-100
   *   - `pm_mode` (required): perceptual masking, 0 off, 1 client-side, 2 standard, 3 JND
   *   - `seed` (required): -1 to 31
   *   - `sp_width`, `sp_height`: 5-64, default 16
   *   - `fec`: 0 repeat or 2 Reed-Muller, default 2
   * - `encoding_ladder`: omit it for the default ladder (h264, CRF 23, 640/864/1280/1920 wide, DASH and HLS). Either one group's keys at the top level, as above, or `"groups": [...]` with one group per codec (`h264`, `h265`/`hevc`, `av1`). Each group states `codec`, `renditions` (`width`, optionally `max_bitrate`, `avg_bitrate`, `crf`, `min_bitrate`, `bufsize`) and `outputs` (`dash`, `hls`), plus `crf` when some rendition names no target of its own; `crf` is refused under `two_pass`. Optional per group: `profile`, `preset`, `pixfmt`, `two_pass`, and `encoder_params` (h265/av1 only, `{name: value}` appended to `-x265-params` / `-svtav1-params`, e.g. `{"sao": 0, "psy-rd": 1}`; keys the template sets itself, such as `keyint` or `vbv-maxrate`, are refused). A rendition without `max_bitrate` is encoded uncapped and must state its own `avg_bitrate` or `crf` (an av1 rendition can only use `crf`, because av1 refuses `avg_bitrate` on every rendition); `bufsize` and `min_bitrate` need `max_bitrate`. A rendition's `crf` overrides the group's for that rung, and inside a `two_pass` group keeps that rung a single constant-quality pass; it excludes `avg_bitrate`. CRF may be fractional, 0-51 for h264/h265 and 0-63 for av1. Shared across groups: `gop_in_seconds` (default 4), `gops_per_segment` (default 1), `exceed_input_resolution`, `drm_streamtypes`, `audio_layouts`, `audio_renditions`. `"groups": []` with a top-level `outputs` declares an audio-only delivery.
   * - `encrypt`: encrypt and register DRM keys with DRMtoday. `protection_systems`: a subset of Widevine, PlayReady, FairPlay (default: all three).
   * - `onboard`, `onboard_tags`, `onboard_window`: also ingest the keys into DRMtoday Onboard (with `encrypt` only).
   * - `thumbs`: generate thumbnails.
   *
   * ## `cmaf-abr` (v1, start_workflow_vod_default)
   *
   * Stardust, as flat `sd_*` keys:
   *
   *     {
   *       "watermark": "stardust/sf",
   *       "sd_wm_id": 1234,
   *       "sd_bit_profile": 13,
   *       "sd_strength": 4,
   *       "sd_pixel_density": 60,
   *       "sd_superpixel_density": 60,
   *       "sd_pm_mode": 2,
   *       "sd_seed": -1
   *     }
   *
   * `sd_wm_id`, `sd_bit_profile`, `sd_strength`, `sd_pixel_density`, `sd_superpixel_density`, `sd_pm_mode` and `sd_seed` are required. `sd_sp_width`, `sd_sp_height` (default 16) and `sd_fec` (default 2) are optional. The value ranges are those of `stardustmark` above.
   *
   * ContentArmor A/B:
   *
   *     {
   *       "watermark":  "contentarmor/ab",
   *       "ab_shared_session_key": "[512 Bit base 64 encoded key]",
   *       "ab_payload_size": "4" | "8" |  "16" | "24" | "32",
   *       "ab_segment_duration": "1" | "2" |  "3" | "4",
   *     }
   *
   * Also `encrypt` and `thumbs`, as for v2.
   *
   * ## `cmaf-abr` (start_workflow_vod_batch)
   *
   *     {
   *       "watermark": "contentarmor/embed",
   *       "ca_payload_size": "4" | "8" |  "16" | "24" | "32",
   *       "ca_watermarks": [1 <= x <= 2^ca_payload_size, ..., 1 <= x <= 2^ca_payload_size],
   *     }
   */
  format_specific_data?: InputMaybe<Scalars['AWSJSON']['input']>;
  /** source bucket/prefix of the media source location. */
  input_brefix: Scalars['String']['input'];
  /** Destination for final delivery of the PO files. 'vod' is the only supported value at this time. */
  po_destination: Scalars['String']['input'];
  /** Identifier for the PO item within the PO. */
  po_item_id: Scalars['String']['input'];
  /** Name of the PO, prefixed with [your_org_name]-... . Please stick to a basic character set. */
  po_name: Scalars['String']['input'];
  /**
   * VTK template to use for encode and encryption, named without its `vod-default-` / `vod-batch-` prefix.
   *
   * - `start_workflow_vod_default`: `cmaf-abr-v2` (vod-default-cmaf-abr-v2, the configurable ladder) or `cmaf-abr` (v1, a fixed four-rendition H.264 ladder, with STARDUSTmark or ContentArmor A/B).
   * - `start_workflow_vod_batch`: `cmaf-abr`.
   *
   * The keys `format_specific_data` accepts depend on this template; see there.
   */
  vtk_template: Scalars['String']['input'];
};

export type TemplateCapabilities = {
  __typename?: 'TemplateCapabilities';
  /** Whether the template takes audio tracks. Same values as video_track. */
  audio_track?: Maybe<TrackRequirement>;
  /** The format_specific_data a job gets when it sends none (absent, null or {}). Used whole, never merged. {} when the template has none. */
  default_format_specific_data?: Maybe<Scalars['AWSJSON']['output']>;
  /**
   * What the template delivers, in one line of at most 80 characters (codec, size, rate, container,
   * audio, subtitles), e.g. "H.264 1280x720 4 Mbit/s + AAC 128 kbit/s in MPEG-TS; image-based (SST) subs".
   * Empty for a template that states none.
   */
  description: Scalars['String']['output'];
  /**
   * How to preselect the job-level watermark switch, or null when the template cannot embed a forensic watermark:
   * {"default": false, "auto_select_min_source_duration_seconds": 1800} -- off, but on when the source is at
   * least that long (long-form content). Templates whose watermark is a format_specific_data key carry the same
   * rule in their schema, as x-ui.auto_select on that key.
   */
  forensic_watermark_selection?: Maybe<Scalars['AWSJSON']['output']>;
  /**
   * JSON Schema (2020-12) of the template's format_specific_data, with x-ui hints for rendering a settings form.
   * Always an object schema; a template reading no keys has empty properties.
   */
  format_specific_data_schema?: Maybe<Scalars['AWSJSON']['output']>;
  /** Whether the template takes image tracks (artwork delivered beside the encode). Same values as video_track. */
  image_track?: Maybe<TrackRequirement>;
  /** Whether the template can burn a subtitle into the video (codec_type burntin_subtitle/closedcaption). */
  supports_burnt_in_texttracks: Scalars['Boolean']['output'];
  supports_dynamic_texttracks: Scalars['Boolean']['output'];
  supports_forensic_watermark: Scalars['Boolean']['output'];
  /** Whether the template processes every video track of the job rather than only the first. */
  supports_multiple_video_tracks: Scalars['Boolean']['output'];
  /** Whether the template honours format_specific_data.dyn_subtitle_position (replaces any UI list of template names). */
  supports_subtitle_positioning: Scalars['Boolean']['output'];
  track_match_rules: Array<TrackMatchRule>;
  /** Whether the template takes a video track: none (ignored if sent), optional, or required (the job is refused without one). */
  video_track?: Maybe<TrackRequirement>;
  vtk_template: Scalars['String']['output'];
};

export type TemplateCapabilitiesInput = {
  /** The VTK template name, as in an encoding format's vtk_template. */
  vtk_template: Scalars['String']['input'];
};

export type Track = {
  __typename?: 'Track';
  /** Type of the requested track. Either video, audio, subtitle, closedcaption, or image. */
  codec_type: Scalars['String']['output'];
  /** Language of the requested track. */
  lang?: Maybe<Scalars['String']['output']>;
  /** Messages generated for this specific track during workflow execution. */
  messages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Actual source file with some additional information as determined during workflow execution. */
  source?: Maybe<Source>;
};

export type TrackInput = {
  codec_type: CodecType;
  /** `filename` is required for and used only by image tracks. */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** `lang` is required for audio/subtitle/closedcaption tracks. */
  lang?: InputMaybe<Scalars['String']['input']>;
};

export type TrackMatchRule = {
  __typename?: 'TrackMatchRule';
  expression: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** The track type the rule applies to (video, audio, ...). */
  type: Scalars['String']['output'];
};

export enum TrackRequirement {
  None = 'none',
  Optional = 'optional',
  Required = 'required'
}

export type VtkJob = {
  __typename?: 'VtkJob';
  /** Creation date of the VTK job in ISO 8601 date string format. */
  created?: Maybe<Scalars['AWSDateTime']['output']>;
  /** Unique identifier for the VTK job. */
  id: Scalars['ID']['output'];
  /** Job Bundles are used for grouping jobs together. All jobs in a PO will have the PO's name as the job bundle. */
  job_bundle?: Maybe<Scalars['String']['output']>;
  /** Modified date of the VTK job in ISO 8601 date string format. */
  modified?: Maybe<Scalars['AWSDateTime']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  organization_urn?: Maybe<Scalars['String']['output']>;
  status_text: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type WorkflowProcessPayload = {
  __typename?: 'WorkflowProcessPayload';
  /** The type of action being performed by the process. */
  action?: Maybe<Scalars['String']['output']>;
  /** Additional information related to the action performed by the process. This field is typically only set when the process is in a terminal state. */
  data?: Maybe<Scalars['String']['output']>;
  /** The date and time the process ended. */
  end_date?: Maybe<Scalars['AWSDateTime']['output']>;
  /** A unique identifier for the process. */
  id: Scalars['ID']['output'];
  /** Input that was used to starrt the process. */
  input?: Maybe<Scalars['String']['output']>;
  /** A message indicating the progress of the process. This can be used to provide updates on the process' status to the client. */
  message?: Maybe<Scalars['String']['output']>;
  /** The date and time the process was created. */
  start_date?: Maybe<Scalars['AWSDateTime']['output']>;
  /** The current state of the process. */
  state: ProcessStateEnum;
};
